exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prod_details_tab.active a[data-v-00cd8ad0]{color:#1e824c!important;position:relative}.prod_details_tab.active a[data-v-00cd8ad0]:after{content:\"\";position:absolute;bottom:0;left:50%;-webkit-transform:translateX(-2.5px);-moz-transform:translateX(-2.5px);-ms-transform:translateX(-2.5px);transform:translateX(-2.5px);width:0;height:0;border-left:5px solid rgba(0,0,0,0);border-right:5px solid rgba(0,0,0,0);border-bottom:5px solid #1e824c}.prod_details_tab a[data-v-00cd8ad0]{color:#000!important}", ""]);

// exports
